module.exports = __webpack_public_path__ + "media/images/svg/realestate/appartment-831d36d366128785beb9ec35177b6370.svg";